export default __webpack_public_path__ + "static/usa_texas_lotto-9da11c13a33c1e6515741ad7ebebf51c.png";